import aclEntityApi from '../../aclEntities/services/api'

export default {
  namespaced: true,
  actions: {
    getRoutesAclEntities: async function ({ commit }, payload) {
      return await aclEntityApi.getRoutesAclEntities(payload).then(response => response.data)
    },
 },
}
